import { html } from '@microsoft/fast-element';
import type { CardDeck } from './card-deck.js';

export default html<CardDeck>`
	<slot></slot>
`;